module.exports = __webpack_public_path__ + "img/230.da63a6c0.svg";